import { boolean, fallback } from "valibot"

export const HiDPISchema = fallback(boolean(), true)
